/**
 * SDK 版本号
 * 此文件在构建时自动生成或手动更新
 */
export const VERSION = '0.1.7';
